<template>
  <Autocomplete
    v-model="currentValue"
    :placeholder="placeholder"
    :throttle="600"
    :max-result="maxResult"
    :options="list"
    :pending="isPending"
    :no-results="noResults"
    :errors="errors"
    :disabled="disabled"
    :size="size"
    :theme="theme"
    :with-chevron="withChevron"
    v-bind="$attrs"
    @onSelect="handleSelect"
    @onSearch="handleSearch"
  >
    <template #append="{ results }">
      <div v-if="results.length < 3" class="no-results">
        Если вы не можете найти адрес, пожалуйста, укажите ближайшее
        местоположение.
      </div>

      <div v-else-if="list.length > maxResult" class="suggest">
        Если вы&nbsp;не&nbsp;можете найти ваш населенный пункт, попробуйте
        детализировать адрес или добавить индекс
      </div>
    </template>
  </Autocomplete>
</template>

<script>
import Autocomplete from "@/components/AutoComplete.vue";
import { geoService } from "@/services/geoService";

export default {
  name: "AddressInput",
  components: {
    Autocomplete,
  },
  inheritAttrs: false,
  props: {
    value: {},
    errors: {},
    placeholder: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
    },
    theme: {
      type: String,
    },
    withChevron: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentValue: this.value,
      list: [],
      isPending: false,
      noResults: false,
    };
  },
  computed: {
    maxResult() {
      return 6;
    },
    searchParams() {
      return {
        locations: [{ country: "*" }],
        from_bound: { value: "house" },
        to_bound: { value: "house-flat" },
      };
    },
  },
  watch: {
    value() {
      this.currentValue = this.value;
    },
  },
  methods: {
    handleSelect(data) {
      if (data && typeof data === "object" && data.value) {
        this.$emit("input", data);
        return;
      }
      this.currentValue = "";
      this.$emit("input", "");
    },
    async handleSearch(query) {
      this.isPending = true;
      // this.$emit("input", "");
      let payload = {
        query,
        param: this.searchParams,
      };

      try {
        const { data } = await geoService.suggestDadataAddress(payload);
        const list = data.suggestions.map((n) => {
          const country = n?.data?.country;
          const federal_district = n?.data?.federal_district;
          const region_with_type = n?.data?.region_with_type;
          const city = n?.data?.city || n?.data?.settlement;
          const geo_lon = n?.data?.geo_lon;
          const geo_lat = n?.data?.geo_lat;
          return {
            label: n.unrestricted_value,
            value: n.unrestricted_value,
            country,
            federal_district,
            region_with_type,
            city,
            geo_lon,
            geo_lat,
          };
        });
        this.list = list;
        this.noResults = list.length === 0;
      } catch (error) {
        console.log("error", error);
      }
      this.isPending = false;
    },
  },
};
</script>

<style lang="less" scoped>
.no-results {
  padding: 11px;
  color: @dark-gray-color;
}

.suggest {
  padding: 11px;
  color: @info-color;
}
</style>
